export default __webpack_public_path__ + "static/media/plan_button.b5ac932b.svg";